'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _commonFunctions = require('../../helpers/commonFunctions');

/**
 * Transforms the data in a Redux Form component to the format required by the API.
 * The data should be in the form given by this.props.values in the connected Redux Form
 *   component.
 * @param {Object} formValues - The form values to transform.
 * @param {Object} trackingCode - The referral code.
 * @returns {Object} - The transformed values.
 */
exports.default = function (formConfig, formValues, trackingCode, coverageType) {
  var applicant = formValues.applicant,
      _formValues$applicati = formValues.application,
      additional_data = _formValues$applicati.additional_data,
      effective_date = _formValues$applicati.effective_date,
      expiry_date = _formValues$applicati.expiry_date;


  additional_data.coverage_type = additional_data.policy_type;
  additional_data.group_number = 1;

  return _extends({}, (0, _commonFunctions.transformApplication)(formValues, trackingCode), {
    expiry_date: expiry_date
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/rimi_is/application.js
// module id = 1749
// module chunks = 0